/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_Data_ActInputs */

const de_commons_footer_data_act = /** @type {(inputs: Commons_Footer_Data_ActInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Act`)
};

/** @type {(inputs: Commons_Footer_Data_ActInputs) => LocalizedString} */
const en_commons_footer_data_act = de_commons_footer_data_act;

/**

* @param {Commons_Footer_Data_ActInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_data_act = /** @type {((inputs?: Commons_Footer_Data_ActInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_Data_ActInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_data_act(inputs)
	return en_commons_footer_data_act(inputs)
});